import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ISchoolReq } from '../../../models/schools.model';
import { doGetSchool, doUpdateSchool } from '../../../store/school.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/system/school/Editor';
import {
  errorVariant,
  successVariant,
  warningVariant,
} from '../../../lib/barVariant';

interface IMatch {
  id: string;
}

const SystemSchoolEdit: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { school, isLoading } = useSelector((state: RootState) => state.school);

  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);

  useEffect(() => {
    getSchool(id);
  }, []);

  const getSchool = async (id: any) => {
    const res = await dispatch(doGetSchool(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(
          res?.data?.data || t('common.message.error'),
          errorVariant,
        );
    }
  };

  const onSubmit = async (req: ISchoolReq) => {
    const res = await dispatch(doUpdateSchool(id, req));
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.goBack();
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(
          res?.data?.data || t('common.message.error'),
          errorVariant,
        );
    }
  };

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.school.title4')}
      />
      <Editor school={school || null} onSubmit={onSubmit} />
      <Footer />
    </div>
  );
};

export default SystemSchoolEdit;
